export interface ItemCardStyle {
  cornerRadius?: number | null;
  borderWidth?: number | null;
  padding?: number | null;
}

export function buildItemCardCssRules(
  s: string,
  style: ItemCardStyle | null | undefined,
): string[] {
  if (!style) return [];

  const itemCardProps: string[] = [];
  if (typeof style.cornerRadius === "number") {
    itemCardProps.push(`border-radius: ${style.cornerRadius}px;`);
  }
  if (typeof style.borderWidth === "number") {
    itemCardProps.push(`border-width: ${style.borderWidth}px;`);
  }
  if (typeof style.padding === "number") {
    itemCardProps.push(`padding: ${style.padding}px;`);
  }

  if (itemCardProps.length === 0) return [];

  const itemCardRule = `${s}[data-ui="item-card"] { ${itemCardProps.join(" ")} }`;

  // Generic bordered radio options keep all selection-card props on the same
  // element, so override them directly.
  const optionProps = itemCardProps.map((p) => p.replace(/;$/, " !important;"));
  const optionRule = `${s}[data-ui="option"] { ${optionProps.join(" ")} }`;

  // Checkbox-card-based option surfaces split their box model between an outer
  // wrapper (border/radius) and an inner card (padding). Write to both so the
  // builder's single slider has the same visible effect as the radio options.
  const checkboxCardOuterProps: string[] = [];
  if (typeof style.cornerRadius === "number") {
    checkboxCardOuterProps.push(
      `border-radius: ${style.cornerRadius}px !important;`,
    );
  }
  if (typeof style.borderWidth === "number") {
    checkboxCardOuterProps.push(
      `border-width: ${style.borderWidth}px !important;`,
    );
  }
  const checkboxCardOuterRule =
    checkboxCardOuterProps.length > 0
      ? `${s}[data-ui="method-option"], ${s}[data-ui="return-type-option"] { ${checkboxCardOuterProps.join(" ")} }`
      : undefined;

  const checkboxCardInnerProps: string[] = [];
  if (typeof style.cornerRadius === "number") {
    checkboxCardInnerProps.push(
      `border-radius: ${style.cornerRadius}px !important;`,
    );
  }
  if (typeof style.padding === "number") {
    checkboxCardInnerProps.push(`padding: ${style.padding}px !important;`);
  }
  const checkboxCardInnerRule =
    checkboxCardInnerProps.length > 0
      ? `${s}[data-ui="method-option"] > *, ${s}[data-ui="return-type-option"] > * { ${checkboxCardInnerProps.join(" ")} }`
      : undefined;

  return [
    itemCardRule,
    optionRule,
    checkboxCardOuterRule,
    checkboxCardInnerRule,
  ].filter((rule): rule is string => rule !== undefined);
}
